import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import LineageDrawer from "../components/LineageDrawer/LineageDrawer";
import {
  fetchDataLineage,
  setFilterDataProducts,
  setFilterIntervallo,
  setFilterDataDa,
  setFilterExtendedStatsDomains,
  setFilterDataA,
  fetchDataProducts,
  fetchExtendedStatsDomains,
} from "../store/app/DataQualityStatus/DataQualitySlice";
import LoaderSpin from "../components/loaderSpin/LoaderSpin";


const DataLineage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { productTypeId } = useParams();
  const searchParams = new URLSearchParams(location.search);

  const dataLineagePayload = useSelector(
    (state) => state.dataQualityReducer.dataLineage
  );

  const dataProducts = useSelector(
    (state) => state.dataQualityReducer.dataProducts
  );

  const extendedStatsDomains = useSelector(
    (state) => state.dataQualityReducer.extendedStatsDomains
  );

  const isSpinnerVisible = useSelector(
    (state) => state.dataQualityReducer.loading
  );

  const params = {
    menu: {
      defaultButtons: false,
      buttons: [
        {
          label: "Data Dictionary",
          action: (selectedNode) => {
            console.log("Data Dictionary");
           navigate("/data-catalog/details/" + selectedNode.type_id + "?" + searchParams.toString());
          },
        },
        {
          label: "Quick Search",
          action: (selectedNode) => {

            console.log("dataProducts", dataProducts);

            const matchingIds = dataProducts
              .filter((item) => item.type_id === selectedNode.type_id)
              .map((item) => item.productId);

            const matchingIdsStatuses = extendedStatsDomains
              .filter((item) => item.status_id === 1 || item.status_id === -1)
              .map((item) => item.id);

            console.log("Quick Search");

            console.log("Selected Node:", selectedNode);
            console.log("Matching IDs:", matchingIds);

            dispatch(setFilterDataProducts(matchingIds || []));
            dispatch(setFilterExtendedStatsDomains(matchingIdsStatuses || []));

            dispatch(setFilterIntervallo(-3));

            searchParams.set("dataproducts", JSON.stringify(matchingIds || []));

            searchParams.set(
              "extendedStatsDomains",
              JSON.stringify(matchingIdsStatuses || [])
            );

            searchParams.set("interval", -3);

            navigate("/versioni" + "?" + searchParams);
          },
        },
        {
          label: "Product Lineage",
          action: (selectedNode) => {
            console.log("Product Lineage");
            navigate("/versioni/data-lineage/" + selectedNode.type_id);
          },
        },
      ],
    },
    nodeTooltipKeys: [
      { key: "type_name", displayKey: "Type Name" },
      { key: "type_description", displayKey: "Type Description" },
      { key: "domain_name", displayKey: "Domain Name" },
      { key: "class_name", displayKey: "Class Name" },
    ],
    lineTooltipKeys: [
      { key: "process_name", displayKey: "Process" },
      { key: "process_description", displayKey: "Process Description" },
      { key: "process_type_name", displayKey: "Process Type" },
      { key: "process_is_manual_validation", displayKey: "Is Manual Validation"},
    ],
    primaryKey: "type_id",
    originId: productTypeId,
    originTypeName: dataLineagePayload?.[0]?.type_name || dataLineagePayload?.[0]?.origin_type_name || 'Type',

  };

  useEffect(() => {
    if (!dataProducts || dataProducts.length === 0) {
      dispatch(fetchDataProducts());
    }
    if (!extendedStatsDomains || extendedStatsDomains.length === 0) {
      dispatch(fetchExtendedStatsDomains());
    }

    dispatch(fetchDataLineage(productTypeId));
  }, [navigate]);

  return (
    <>
      <LoaderSpin isVisible={isSpinnerVisible} />
      <LineageDrawer data={dataLineagePayload} params={params} />
    </>
  );
};

export default DataLineage;
